export class SampleRedoDownloadDTO{
    labId: string;
    timeZone: string;
}